import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["forms"]

  pickMethod(event) {
    const methodId = event.currentTarget.dataset.methodId
    // Hide all method forms, show the chosen one
    this.formsTarget.querySelectorAll("[data-method-form]").forEach(el => el.classList.add("hidden"))
    const target = this.formsTarget.querySelector(`[data-method-form='${methodId}']`)
    if (target) target.classList.remove("hidden")
    // Visual feedback on method tiles
    this.element.querySelectorAll(".pu-pos-method-tile.is-active").forEach(el => el.classList.remove("is-active"))
    event.currentTarget.classList.add("is-active")
  }
}
